type ScoreBand = 'A' | 'B' | 'C' | 'D';

const BAND_CLASSES: Record<ScoreBand, string> = {
  A: 'bg-score-a/10 text-score-a',
  B: 'bg-score-b/10 text-score-b',
  C: 'bg-score-c/10 text-score-c',
  D: 'bg-score-d/10 text-score-d',
};

const BAND_LABELS: Record<ScoreBand, string> = {
  A: 'Excellent',
  B: 'Good',
  C: 'Fair',
  D: 'Poor',
};

interface LeadScoreBadgeProps {
  band: ScoreBand;
  score?: number;
  size?: 'sm' | 'md' | 'lg';
}

export function LeadScoreBadge({ band, score, size = 'sm' }: LeadScoreBadgeProps) {
  if (size === 'lg') {
    const BAND_COLORS: Record<ScoreBand, string> = { A: '#06B6D4', B: '#3B82F6', C: '#523EF7', D: '#EF4444' };
    const color = BAND_COLORS[band];
    const pct = score !== undefined ? Math.min(100, Math.max(0, score)) : 50;
    const r = 36;
    const circ = 2 * Math.PI * r;
    const filled = (pct / 100) * circ;
    return (
      <div className="relative w-20 h-20 flex items-center justify-center">
        <svg width="80" height="80" viewBox="0 0 80 80" className="absolute inset-0">
          <circle cx="40" cy="40" r={r} fill="none" stroke="#E8E8E8" strokeWidth="6" />
          <circle
            cx="40" cy="40" r={r} fill="none" stroke={color} strokeWidth="6"
            strokeDasharray={`${filled} ${circ - filled}`}
            strokeDashoffset={circ * 0.25}
            strokeLinecap="round"
            className="transition-all duration-500"
          />
        </svg>
        <div className="flex flex-col items-center">
          <span className="text-2xl font-bold" style={{ color }}>{band}</span>
          {score !== undefined && <span className="text-[10px] text-[#9A9A9A]">{score}</span>}
        </div>
      </div>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${BAND_CLASSES[band]} ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      }`}
    >
      {band}
      {size === 'md' && <span className="font-normal opacity-80">· {BAND_LABELS[band]}</span>}
    </span>
  );
}
